import { render } from "./NoteItem.vue?vue&type=template&id=06e05e7c&scoped=true&ts=true"
import script from "./NoteItem.vue?vue&type=script&lang=ts"
export * from "./NoteItem.vue?vue&type=script&lang=ts"

import "./NoteItem.vue?vue&type=style&index=0&id=06e05e7c&scoped=true&lang=css"

import exportComponent from "/Users/georgemayer/Sites/apps/lognote/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06e05e7c"]])

export default __exports__